import React from "react";

import Layout from '@/Shared/Layout'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import Card from '@/Pages/ItemDescription/Shared/Card'

const Index = () => {

    return (
        <div>
            <BreadCrumbs
                link={route().current()}
                title={`Janitorial Consumable Item Description`}
                subTitle="List"
            />

            <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4">
                <Card
                    thumbnail="/asset/image/disinfectant.jpeg"
                    item="Disinfectant"
                    unitOfMeasurements="2.75 Lit Bottle"
                    manufacturer="Fine Daily"
                    brand="KING SWEEPY PHENYL"
                    packSize="6 Bottles per Box"
                    supplier="M/s GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Liquid Toilet Cleaner.png"
                    item="Liquid Toilet Cleaner"
                    unitOfMeasurements="900 ml Bottle"
                    manufacturer="Reckitt Benckiser"
                    brand="Harpic"
                    packSize="12 Bottles per Box"
                    supplier="M/S Reckitt Benckiser PK LTD"
                />

                <Card
                    thumbnail="/asset/image/Normal Waste Bags.png"
                    item="Normal Waste Bags 21x28 Numbers (1 Kg ~ 30 bags)"
                    unitOfMeasurements="Kg"
                    manufacturer="Local"
                    brand="CUSTOMIZED"
                    packSize="20 Kg per Bag"
                    supplier="M/s GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Normal Waste Bags.png"
                    item="Normal Waste Bags 30x30 Numbers (1 Kg ~ 16 bags)"
                    unitOfMeasurements="Kg"
                    manufacturer="Local"
                    brand="CUSTOMIZED"
                    packSize="20 Kg per Bag"
                    supplier="M/s GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Normal Waste Bags.png"
                    item="Normal Waste Bags 39x45 Numbers (1 Kg ~ 8 bags)"
                    unitOfMeasurements="Kg"
                    manufacturer="Local"
                    brand="CUSTOMIZED"
                    packSize="20 Kg per Bag"
                    supplier="M/s GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Air Freshener.jpg"
                    item="Air Freshener"
                    unitOfMeasurements="Bottles"
                    manufacturer="FINE DAILY"
                    brand="FREY"
                    packSize="Per Bottle"
                    supplier="M/s GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Brooms.jpeg"
                    item="Brooms"
                    unitOfMeasurements="1.5 Kg Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="12 articles per Bag"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Furniture Dusters.jpg"
                    item="Furniture Dusters"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="40 pieces per Bag"
                    supplier="M/S AL-FALAH TRADERS"
                />

                <Card
                    thumbnail="/asset/image/Hand Wash Liquid.jpeg"
                    item="Hand Wash Liquid"
                    unitOfMeasurements="Liters"
                    manufacturer="COLGATE-PALMOLIVE"
                    brand="PALMOLIVE ANTIBACTERIAL HW"
                    packSize="8 Pouches per Box"
                    supplier="M/S GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Hand Wash Dispenser.jpeg"
                    item="Hand Wash Dispenser"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="Per Article"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Floor Mops Standard.jpeg"
                    item="Floor Mops Standard"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="Per Unit"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Mop Pads.jpg"
                    item="Mop Pads"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="Pack of 4"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Wipers.jpg"
                    item="Wipers"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="Per Unit"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Floor Cleaning Towel.jpg"
                    item="Floor Cleaning Towel"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="Pack of 12"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Disposable Bedsheet.jpeg"
                    item="Disposable Bedsheet"
                    unitOfMeasurements="Articles"
                    manufacturer="LOCAL"
                    brand="CUSTOMIZED"
                    packSize="Pack of 12"
                    supplier="M/S CRYSTAL FABRICATION"
                />

                <Card
                    thumbnail="/asset/image/Air Freshener.jpg"
                    item="Air Freshener Dispenser (Machines)"
                    unitOfMeasurements="Bottles"
                    manufacturer="FINE DAILY"
                    brand="FREY"
                    packSize="Per Bottle"
                    supplier="M/s GREENZ INTERNATIONAL"
                />

                <Card
                    thumbnail="/asset/image/Air Freshener.jpg"
                    item="Air Freshener Dispenser Refills"
                    unitOfMeasurements="Bottles"
                    manufacturer="FINE DAILY"
                    brand="FREY"
                    packSize="Per Bottle"
                    supplier="M/s GREENZ INTERNATIONAL"
                />
            </div>
        </div>
    )
}

Index.layout = page =>
    <Layout title="Janitorial Item Description" children={page} />

export default Index
